<template>
    <b-row>
        <b-col>
            <b-row>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Inizio</label>
                    <date-picker v-if="!isReadOnly" v-model="jsonData.dataInizio" format="DD-MM-YYYY" value-type="timestamp" type="date" placeholder="Seleziona una data inizio"></date-picker>
                </b-col>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Fine</label>
                    <date-picker v-model="jsonData.dataFine" format="DD-MM-YYYY" value-type="timestamp" type="date" placeholder="Seleziona una data fine"></date-picker>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">Stabilire alleanza terapeutica funzionale:</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.stabilireAlleanzaTerapeuticaFunzionale" :options="options" text-field="text" value-field="value"> </b-form-select>
                    <span v-else>{{ jsonData.stabilireAlleanzaTerapeuticaFunzionale }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="7" lg="7" xl="7">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.stabilireAlleanzaTerapeuticaFunzionaleDettaglio" :readonly="isReadOnly" :disabled="jsonData.stabilireAlleanzaTerapeuticaFunzionale !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.stabilireAlleanzaTerapeuticaFunzionaleDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">Adeguamento della terapia farmacologica:</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.adeguamentoDellaTerapiaFarmacologica" :options="options" text-field="text" value-field="value"> </b-form-select>
                    <span v-else>{{ jsonData.adeguamentoDellaTerapiaFarmacologica }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="7" lg="7" xl="7">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.adeguamentoDellaTerapiaFarmacologicaDettaglio" :readonly="isReadOnly" :disabled="jsonData.adeguamentoDellaTerapiaFarmacologica !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.adeguamentoDellaTerapiaFarmacologicaDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">Compenso farmacologico sintomatologia psichiatrica:</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.compensoFarmacologicoSintomatologiaPsichiatrica" :options="options" text-field="text" value-field="value"></b-form-select>
                    <span v-else>{{ jsonData.compensoFarmacologicoSintomatologiaPsichiatrica }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="7" lg="7" xl="7">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.compensoFarmacologicoSintomatologiaPsichiatricaDettaglio" :readonly="isReadOnly" :disabled="jsonData.compensoFarmacologicoSintomatologiaPsichiatrica !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.compensoFarmacologicoSintomatologiaPsichiatricaDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">Gestione autonoma dell'assunzione della terapia farmacologica:</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.gestioneAutonomaAssunzioneTerapiaFarmacologica" :options="options" text-field="text" value-field="value"></b-form-select>
                    <span v-else>{{ jsonData.gestioneAutonomaAssunzioneTerapiaFarmacologica }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="7" lg="7" xl="7">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.gestioneAutonomaAssunzioneTerapiaFarmacologicaDettaglio" :readonly="isReadOnly" :disabled="jsonData.gestioneAutonomaAssunzioneTerapiaFarmacologica !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.gestioneAutonomaAssunzioneTerapiaFarmacologicaDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">Colloquio psicologico clinico:</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.colloquioPsicologicoClinico" :options="options" text-field="text" value-field="value"></b-form-select>
                    <span v-else>{{ jsonData.colloquioPsicologicoClinico }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="7" lg="7" xl="7">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.colloquioPsicologicoClinicoDettaglio" :readonly="isReadOnly" :disabled="jsonData.colloquioPsicologicoClinico !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.colloquioPsicologicoClinicoDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">Psicoterapia individuale e/o gruppo:</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.psicoterapiaIndividualeGruppo" :options="options" text-field="text" value-field="value"></b-form-select>
                    <span v-else>{{ jsonData.psicoterapiaIndividualeGruppo }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="7" lg="7" xl="7">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.psicoterapiaIndividualeGruppoDettaglio" :readonly="isReadOnly" :disabled="jsonData.psicoterapiaIndividualeGruppo !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.psicoterapiaIndividualeGruppoDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">Valutazione psicodiagnostica:</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.valutazionePsicodiagnostica" :options="options" text-field="text" value-field="value"></b-form-select>
                    <span v-else>{{ jsonData.valutazionePsicodiagnostica }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="7" lg="7" xl="7">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.valutazionePsicodiagnosticaDettaglio" :readonly="isReadOnly" :disabled="jsonData.valutazionePsicodiagnostica !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.valutazionePsicodiagnosticaDettaglio }}</span>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import datePicker from "vue2-datepicker";

export default {
    components: { datePicker },
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },
    data() {
        return {
            options: [
                { value: null, text: "- Seleziona Valore -" },
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
            jsonData: {
                id: null,
                idAccettazione: null,
                dataInizio: null,
                dataFine: null,
                stabilireAlleanzaTerapeuticaFunzionale: null,
                stabilireAlleanzaTerapeuticaFunzionaleDettaglio: null,
                adeguamentoDellaTerapiaFarmacologica: null,
                adeguamentoDellaTerapiaFarmacologicaDettaglio: null,
                compensoFarmacologicoSintomatologiaPsichiatrica: null,
                compensoFarmacologicoSintomatologiaPsichiatricaDettaglio: null,
                gestioneAutonomaAssunzioneTerapiaFarmacologica: null,
                gestioneAutonomaAssunzioneTerapiaFarmacologicaDettaglio: null,
                colloquioPsicologicoClinico: null,
                colloquioPsicologicoClinicoDettaglio: null,
                psicoterapiaIndividualeGruppo: null,
                psicoterapiaIndividualeGruppoDettaglio: null,
                valutazionePsicodiagnostica: null,
                valutazionePsicodiagnosticaDettaglio: null,
                params: "",
                nomeProgetto: "PROGETTO PSICOLOGICO",
            },
            pathResourceProgettoPsicologico: "/rsapazientesrprogettopsicologico",
            nomeProgetto: "PROGETTO PSICOLOGICO",
            params: "",
        };
    },
    watch: {
        "jsonData.stabilireAlleanzaTerapeuticaFunzionale"(v) {
            if (v !== "SI") {
                this.jsonData.stabilireAlleanzaTerapeuticaFunzionaleDettaglio = null;
            }
        },
        "jsonData.adeguamentoDellaTerapiaFarmacologica"(v) {
            if (v !== "SI") {
                this.jsonData.adeguamentoDellaTerapiaFarmacologicaDettaglio = null;
            }
        },
        "jsonData.compensoFarmacologicoSintomatologiaPsichiatrica"(v) {
            if (v !== "SI") {
                this.jsonData.compensoFarmacologicoSintomatologiaPsichiatricaDettaglio = null;
            }
        },
        "jsonData.gestioneAutonomaAssunzioneTerapiaFarmacologica"(v) {
            if (v !== "SI") {
                this.jsonData.gestioneAutonomaAssunzioneTerapiaFarmacologicaDettaglio = null;
            }
        },
        "jsonData.colloquioPsicologicoClinico"(v) {
            if (v !== "SI") {
                this.jsonData.colloquioPsicologicoClinicoDettaglio = null;
            }
        },
        "jsonData.psicoterapiaIndividualeGruppo"(v) {
            if (v !== "SI") {
                this.jsonData.psicoterapiaIndividualeGruppoDettaglio = null;
            }
        },
        "jsonData.valutazionePsicodiagnostica"(v) {
            if (v !== "SI") {
                this.jsonData.valutazionePsicodiagnosticaDettaglio = null;
            }
        },
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$route.params.id;
        let params = { progettoPsicologico: "si" };
        me.params = JSON.stringify(params);
        me.jsonData = {
            idAccettazione: me.idAccettazione,
            dataInizio: new Date().getTime(),
            dataFine: null,
            stabilireAlleanzaTerapeuticaFunzionale: null,
            stabilireAlleanzaTerapeuticaFunzionaleDettaglio: null,
            adeguamentoDellaTerapiaFarmacologica: null,
            adeguamentoDellaTerapiaFarmacologicaDettaglio: null,
            compensoFarmacologicoSintomatologiaPsichiatrica: null,
            compensoFarmacologicoSintomatologiaPsichiatricaDettaglio: null,
            gestioneAutonomaAssunzioneTerapiaFarmacologica: null,
            gestioneAutonomaAssunzioneTerapiaFarmacologicaDettaglio: null,
            colloquioPsicologicoClinico: null,
            colloquioPsicologicoClinicoDettaglio: null,
            psicoterapiaIndividualeGruppo: null,
            psicoterapiaIndividualeGruppoDettaglio: null,
            valutazionePsicodiagnostica: null,
            valutazionePsicodiagnosticaDettaglio: null,
            params: me.params,
            nomeProgetto: "PROGETTO PSICOLOGICO",
        };
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    methods: {
        loadData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceProgettoPsicologico + "/" + me.idRisorsa, {}, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.nomeProgetto = me.nomeProgetto;
            me.jsonData.params = me.params;
            me.jsonData.idAccettazione = me.idAccettazione;
        },
        loadDataError(error) {
            console.log(error);
        },
    },
};
</script>
